export const ColorProp = {
    PrimaryPolicy: 'primaryPolicy',

    GuestSuccess: 'guestSuccess',
    GuestConsider: 'guestConsider',
    GuestProcessing: 'guestProcessing',
    GuestDefault: 'guestDefault',

    ReservationStatusUpcoming: 'reservationStatusUpcoming',
    ReservationStatusInHome: 'reservationStatusInHome',
    ReservationStatusComplete: 'reservationStatusComplete',
    ReservationStatusClaimFiled: 'reservationStatusClaimFiled',
    ReservationStatusCanceled: 'reservationStatusCanceled',
    ReservationStatusDefault: 'reservationStatusDefault',

    NewClaimAfter60Days: 'newClaimAfter60Days',

    ClaimStatusDraft: 'claimStatusDraft',
    ClaimStatusInProgress: 'claimStatusInProgress',
    ClaimStatusComplete: 'claimStatusComplete',

    FilterPillBackground: 'filterPillBackground',

    PropertyStatusActive: 'propertyStatusActive',

    StatusPillColor: 'statusPillColor',
} as const;

export type ColorPropType = typeof ColorProp[keyof typeof ColorProp];

export const Colors = {
    Safely: {
        primaryPolicy: '#5cb85c',
        
        guestSuccess: 'lightgreen',
        guestConsider: '#0086c3',
        guestProcessing: '#b3e5fc',
        guestDefault: 'lightgray',

        reservationStatusUpcoming: '#d3d3d3',
        reservationStatusInHome: '#ffdd00',
        reservationStatusComplete: 'lightgreen',
        reservationStatusClaimFiled: '#ED6C23',
        reservationStatusCanceled: 'red',
        reservationStatusDefault: 'grey',

        newClaimAfter60Days: '#23a4ed',

        claimStatusDraft: '#778898',
        claimStatusInProgress: '#f29b02',
        claimStatusComplete: '#79c91c',

        filterPillBackground: '#FF9729',

        propertyStatusActive: 'lightgreen',

        statusPillColor: 'black',
    },
    CoverCat: {
        primaryPolicy: '#5cb85c',
        
        guestSuccess: 'lightgreen',
        guestConsider: '#0086c3',
        guestProcessing: '#b3e5fc',
        guestDefault: 'lightgray',

        reservationStatusUpcoming: '#d3d3d3',
        reservationStatusInHome: '#ffdd00',
        reservationStatusComplete: 'lightgreen',
        reservationStatusClaimFiled: '#ED6C23',
        reservationStatusCanceled: 'red',
        reservationStatusDefault: 'grey',

        newClaimAfter60Days: 'grey',

        claimStatusDraft: '#778898',
        claimStatusInProgress: '#f29b02',
        claimStatusComplete: '#79c91c',

        filterPillBackground: '#FF9729',

        propertyStatusActive: 'lightgreen',

        statusPillColor: 'black',
    }
} as const;

export function getColor(property: ColorPropType): string {
    return Colors.Safely[property];
}